<!-- <div class="row">
  <div class="col-md-10">
    <div class="scrollspy-example scrollspy-container">
      <section mdbScrollspyElement="scrollspy" id="multi-family">
        <h3>Multi-Family</h3>
        <p>
          Multi-family properties are an essential segment of the real estate market, providing residential housing options across various demographic segments. Investors seek multi-family properties for their potential to generate stable rental income and long-term appreciation.
        </p>
        <p>
          The demand for multi-family properties has surged in urban centers, driven by shifting lifestyle preferences and affordability concerns. Young professionals and small families often prefer renting over homeownership due to flexibility and lower upfront costs.
        </p>
        <p>
          Amenities and modern conveniences play a critical role in multi-family property success. Features such as fitness centers, co-working spaces, and community engagement areas enhance tenant retention and property value.
        </p>
        <p>
          Cushman & Wakefield provides in-depth market insights to help investors identify lucrative multi-family opportunities. Our advisory services cater to institutional and private investors, ensuring optimized investment strategies.
        </p>
        <p>
          Sustainability is also gaining traction in multi-family developments. Energy-efficient designs, smart home technology, and green certifications are becoming essential components for new projects.
        </p>
        <p>
          With evolving tenant expectations, property owners must adopt innovative approaches to property management, including technology-driven solutions to enhance tenant experience and operational efficiency.
        </p>
      </section>

      <section mdbScrollspyElement="scrollspy" id="office">
        <h3>Office</h3>
        <p>
          The office real estate market is undergoing a transformation as businesses reassess their workspace requirements in the post-pandemic era. Hybrid work models have altered traditional office demand, leading to a shift in leasing strategies.
        </p>
        <p>
          Prime office locations continue to attract businesses seeking well-connected, amenity-rich work environments. Flexible workspaces, coworking hubs, and collaborative zones have become key elements in office space design.
        </p>
        <p>
          Sustainability and wellness initiatives are reshaping office developments. Companies prioritize LEED-certified buildings, improved air quality systems, and wellness programs to attract and retain employees.
        </p>
        <p>
          Cushman & Wakefield assists occupiers and investors in navigating these market changes, offering solutions to maximize office space efficiency while aligning with corporate goals.
        </p>
        <p>
          Digitalization is revolutionizing office spaces, with smart technology, AI-driven workspace optimization, and IoT-based energy management enhancing operational efficiency.
        </p>
        <p>
          The future of office real estate lies in adaptability. Landlords and tenants alike must embrace flexible lease structures and innovative design concepts to cater to evolving workforce expectations.
        </p>
      </section>

      <section mdbScrollspyElement="scrollspy" id="industrial">
        <h3>Industrial</h3>
        <p>
          Industrial real estate is witnessing unprecedented growth, driven by the rapid expansion of e-commerce and supply chain modernization. Warehousing and logistics hubs are at the forefront of this sector’s evolution.
        </p>
        <p>
          Proximity to major transportation nodes is a critical factor in industrial site selection. Businesses seek locations that optimize distribution networks and minimize last-mile delivery costs.
        </p>
        <p>
          Automation and technology integration have transformed warehouse operations. Robotics, AI-driven inventory management, and predictive analytics enhance efficiency and reduce operational costs.
        </p>
        <p>
          Cushman & Wakefield provides expert advisory on industrial property acquisitions, leasing strategies, and development trends, ensuring clients capitalize on market opportunities.
        </p>
        <p>
          Sustainability efforts are gaining momentum in industrial real estate. Green warehousing solutions, solar energy utilization, and energy-efficient building materials are reshaping the sector.
        </p>
        <p>
          The growing prominence of cold storage facilities and data centers underscores the evolving demands within industrial real estate, driven by shifts in consumer behavior and technological advancements.
        </p>
      </section>

      <section mdbScrollspyElement="scrollspy" id="living-sector">
        <h3>Living Sector</h3>
        <p>
          The living sector encompasses a broad range of residential real estate assets, including purpose-built rentals, student housing, and co-living spaces. This sector has emerged as a resilient asset class, driven by demographic trends and lifestyle shifts.
        </p>
        <p>
          Purpose-built rental communities offer long-term housing solutions for urban dwellers seeking professionally managed residences with high-end amenities and flexible lease terms.
        </p>
        <p>
          Cushman & Wakefield provides expert advisory on living sector property acquisitions, leasing strategies, and development trends, ensuring clients capitalize on market opportunities.
        </p>
        <p>
          Student housing remains a strong investment category, with demand fueled by increasing global student mobility and rising university enrollments. Modern student accommodations prioritize connectivity, security, and social spaces.
        </p>
        <p>
          The living sector encompasses a broad range of residential real estate assets, including purpose-built rentals, student housing, and co-living spaces. This sector has emerged as a resilient asset class, driven by demographic trends and lifestyle shifts.
        </p>
        <p>
          Purpose-built rental communities offer long-term housing solutions for urban dwellers seeking professionally managed residences with high-end amenities and flexible lease terms.
        </p>
        <p>
          The living sector encompasses a broad range of residential real estate assets, including purpose-built rentals, student housing, and co-living spaces. This sector has emerged as a resilient asset class, driven by demographic trends and lifestyle shifts.
        </p>
        <p>
          Student housing remains a strong investment category, with demand fueled by increasing global student mobility and rising university enrollments. Modern student accommodations prioritize connectivity, security, and social spaces.
        </p>
        <p>
          The living sector encompasses a broad range of residential real estate assets, including purpose-built rentals, student housing, and co-living spaces. This sector has emerged as a resilient asset class, driven by demographic trends and lifestyle shifts.
        </p>
        <p>
          Purpose-built rental communities offer long-term housing solutions for urban dwellers seeking professionally managed residences with high-end amenities and flexible lease terms.
        </p>
        <p>
          The living sector encompasses a broad range of residential real estate assets, including purpose-built rentals, student housing, and co-living spaces. This sector has emerged as a resilient asset class, driven by demographic trends and lifestyle shifts.
        </p>
        <p>
          Student housing remains a strong investment category, with demand fueled by increasing global student mobility and rising university enrollments. Modern student accommodations prioritize connectivity, security, and social spaces.
        </p>
        <p>
          The living sector encompasses a broad range of residential real estate assets, including purpose-built rentals, student housing, and co-living spaces. This sector has emerged as a resilient asset class, driven by demographic trends and lifestyle shifts.
        </p>
        <p>
          Co-living spaces have gained traction, particularly in metropolitan markets where affordability and community living are key priorities. These spaces emphasize shared amenities and flexible leasing options.
        </p>
        <p>
          Cushman & Wakefield's expertise in the living sector helps investors identify high-growth markets and optimize asset performance through strategic advisory and market intelligence.
        </p>
        <p>
          The integration of smart home technology, sustainable building materials, and community-centric designs is shaping the future of the living sector, making it an attractive investment avenue.
        </p>
      </section>

      <section mdbScrollspyElement="scrollspy" id="senior-housing">
        <h3>Senior Housing</h3>
        <p>
          The senior housing market is expanding as aging populations drive demand for specialized housing solutions. Independent living, assisted living, and memory care facilities cater to diverse needs within this segment.
        </p>
        <p>
          Quality of care, lifestyle amenities, and healthcare accessibility are crucial factors influencing senior housing investment decisions. Developers focus on creating comfortable, engaging environments for residents.
        </p>
        <p>
          Technological advancements, including remote health monitoring, AI-driven care management, and telemedicine integration, are reshaping senior housing facilities.
        </p>
        <p>
          Cushman & Wakefield provides market insights and strategic guidance to investors looking to enter or expand in the senior housing sector, ensuring informed decision-making.
        </p>
        <p>
          The shift towards hybrid senior living models, combining healthcare services with hospitality-driven amenities, is redefining industry standards.
        </p>
        <p>
          The shift towards hybrid senior living models, combining healthcare services with hospitality-driven amenities, is redefining industry standards.
        </p>
        <p>
          The shift towards hybrid senior living models, combining healthcare services with hospitality-driven amenities, is redefining industry standards.
        </p>
        <p>
          Cushman & Wakefield provides market insights and strategic guidance to investors looking to enter or expand in the senior housing sector, ensuring informed decision-making.
        </p>
        <p>
          The shift towards hybrid senior living models, combining healthcare services with hospitality-driven amenities, is redefining industry standards.
        </p>
        <p>
          Cushman & Wakefield provides market insights and strategic guidance to investors looking to enter or expand in the senior housing sector, ensuring informed decision-making.
        </p>
        <p>
          The shift towards hybrid senior living models, combining healthcare services with hospitality-driven amenities, is redefining industry standards.
        </p>
        <p>
          With evolving expectations, the future of senior housing lies in offering personalized, technology-enhanced living experiences that prioritize safety, wellness, and social engagement.
        </p>
      </section>
    </div>
  </div>

  <div class="col-md-2">
    <div id="scrollspy" class="sticky-top">
      <ul mdbScrollspy="scrollspy" class="nav flex-column nav-pills menu-sidebar">
        <li class="nav-item"><a mdbScrollspyLink="multi-family" class="nav-link">Multi-Family</a></li>
        <li class="nav-item"><a mdbScrollspyLink="office" class="nav-link">Office</a></li>
        <li class="nav-item"><a mdbScrollspyLink="industrial" class="nav-link">Industrial</a></li>
        <li class="nav-item"><a mdbScrollspyLink="living-sector" class="nav-link">Living Sector</a></li>
        <li class="nav-item"><a mdbScrollspyLink="senior-housing" class="nav-link">Senior Housing</a></li>
      </ul>
    </div>
  </div>
</div> -->
<div class="container">
  <h2 class="text-center">Valuation Details</h2>
  <!-- <mdb-tabs>
    <mdb-tab>
      <ng-template mdbTabTitle><span><i class="fas fa-chart-pie fa-fw me-2"></i>Property Type & Tenancy</span></ng-template>
      <div class="row">
        <div class="col-md-10">
          <div class="scrollspy-example scrollspy-container">
            <section mdbScrollspyElement="scrollspy" id="multi-family">
              <div class="form-section col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label">Property Type</label>
                    <input type="text" class="form-control form-control-sm" value="1">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Property Subtype</label>
                    <input type="text" class="form-control form-control-sm" value="2">
                  </div>
                </div>
                <div class="col-md-6 mt-2">
                  <label class="form-label">Tenancy</label>
                  <input type="text" class="form-control form-control-sm" value="3">
                </div>
              </div>
            </section>
      
            <section mdbScrollspyElement="scrollspy" id="office">
              <div class="form-section col-md-6">
                <h4><span><i class="fas fa-map-marker-alt fa-fw me-2"></i>Subject Property Location</span></h4>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label">Property Name</label>
                    <input type="text" class="form-control form-control-sm" value="4">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Address</label>
                    <input type="text" class="form-control form-control-sm" value="5">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">City</label>
                    <input type="text" class="form-control form-control-sm" value="6">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">County</label>
                    <input type="text" class="form-control form-control-sm" value="7">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">State</label>
                    <input type="text" class="form-control form-control-sm" value="">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">Zipcode</label>
                    <input type="text" class="form-control form-control-sm" value="">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">Country</label>
                    <input type="text" class="form-control form-control-sm" value="">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">Region</label>
                    <input type="text" class="form-control form-control-sm" value="">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">MSA</label>
                    <input type="text" class="form-control form-control-sm" value="">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">Market</label>
                    <input type="text" class="form-control form-control-sm" value="">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">Submarket</label>
                    <input type="text" class="form-control" value="">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">Street Location</label>
                    <input type="text" class="form-control" value="">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">Latitude</label>
                    <input type="text" class="form-control" value="">
                  </div>
                  <div class="col-md-6 mt-2">
                    <label class="form-label">Longitude</label>
                    <input type="text" class="form-control" value="">
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="col-md-2">
          <div id="scrollspy" class="sticky-top">
            <ul mdbScrollspy="scrollspy" class="nav flex-column nav-pills menu-sidebar">
              <li class="nav-item"><a mdbScrollspyLink="multi-family" [scrollIntoView]="true" class="nav-link">Overiew</a></li>
              <li class="nav-item"><a mdbScrollspyLink="office" [scrollIntoView]="true" class="nav-link">Location Info</a></li>
            </ul>
          </div>
        </div>
      </div>
    </mdb-tab>
  </mdb-tabs> -->
  <!-- Large button groups (default and split) -->
  <div mdbDropdown class="btn-group">
    <button class="btn btn-primary btn-lg dropdown-toggle" type="button" mdbDropdownToggle aria-expanded="false">
      Large button
    </button>
    <ul mdbDropdownMenu class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Action</a></li>
      <li><a class="dropdown-item" href="#">Another action</a></li>
      <li><a class="dropdown-item" href="#">Something else here</a></li>
      <li>
        <hr class="dropdown-divider" />
      </li>
      <li><a class="dropdown-item" href="#">Separated link</a></li>
    </ul>
  </div>
  <div mdbDropdown class="btn-group">
    <button class="btn btn-primary btn-lg" type="button">Large split button</button>
    <button type="button" class="btn btn-lg btn-primary dropdown-toggle dropdown-toggle-split" mdbDropdownToggle
      aria-expanded="false">
      <span class="visually-hidden">Toggle Dropdown</span>
    </button>
    <ul mdbDropdownMenu class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Action</a></li>
      <li><a class="dropdown-item" href="#">Another action</a></li>
      <li><a class="dropdown-item" href="#">Something else here</a></li>
      <li>
        <hr class="dropdown-divider" />
      </li>
      <li><a class="dropdown-item" href="#">Separated link</a></li>
    </ul>
  </div>
  <!-- Small button groups (default and split) -->
  <div mdbDropdown class="btn-group">
    <button class="btn btn-primary btn-sm dropdown-toggle" type="button" mdbDropdownToggle aria-expanded="false">
      Small button
    </button>
    <ul mdbDropdownMenu class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Action</a></li>
      <li><a class="dropdown-item" href="#">Another action</a></li>
      <li><a class="dropdown-item" href="#">Something else here</a></li>
      <li>
        <hr class="dropdown-divider" />
      </li>
      <li><a class="dropdown-item" href="#">Separated link</a></li>
    </ul>
  </div>
  <div mdbDropdown class="btn-group">
    <button class="btn btn-primary btn-sm" type="button">Small split button</button>
    <button type="button" class="btn btn-sm btn-primary dropdown-toggle dropdown-toggle-split" mdbDropdownToggle
      aria-expanded="false">
      <span class="visually-hidden">Toggle Dropdown</span>
    </button>
    <ul mdbDropdownMenu class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Action</a></li>
      <li><a class="dropdown-item" href="#">Another action</a></li>
      <li><a class="dropdown-item" href="#">Something else here</a></li>
      <li>
        <hr class="dropdown-divider" />
      </li>
      <li><a class="dropdown-item" href="#">Separated link</a></li>
    </ul>
  </div>
</div>
<!-- Default dropleft button -->
<div mdbDropdown class="btn-group dropstart">
  <button type="button" class="btn btn-primary dropdown-toggle" mdbDropdownToggle aria-expanded="false">
    Dropleft
  </button>
  <ul mdbDropdownMenu class="dropdown-menu">
    <li><a class="dropdown-item" href="#">Action</a></li>
    <li><a class="dropdown-item" href="#">Another action</a></li>
    <li><a class="dropdown-item" href="#">Something else here</a></li>
    <li>
      <hr class="dropdown-divider" />
    </li>
    <li><a class="dropdown-item" href="#">Separated link</a></li>
  </ul>
</div>
<!-- Split dropleft button -->
<div class="btn-group">
  <div mdbDropdown class="btn-group dropstart" role="group">
    <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" mdbDropdownToggle
      aria-expanded="false">
      <span class="visually-hidden">Toggle Dropleft</span>
    </button>
    <ul mdbDropdownMenu class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Action</a></li>
      <li><a class="dropdown-item" href="#">Another action</a></li>
      <li><a class="dropdown-item" href="#">Something else here</a></li>
      <li>
        <hr class="dropdown-divider" />
      </li>
      <li><a class="dropdown-item" href="#">Separated link</a></li>
    </ul>
  </div>
  <button type="button" class="btn btn-primary">Split dropleft</button>
</div>
<div class="container">
    <div>
      <button class="export" (click)="onBtExport()">Export to Excel</button>
    </div>
    <div class="grid-wrapper">
      <ag-grid-angular
        style="width: 100%; height: 100%;"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [defaultExcelExportParams]="defaultExcelExportParams"
        [rowData]="rowData"
        (gridReady)="onGridReady($event)"
      />
    </div>
  </div> 